import watch from "redux-watch";
import isEqual from 'is-equal';
import PNotify from 'pnotify/dist/es/PNotify';
// import PNotifyButtons from 'pnotify/dist/es/PNotifyButtons';
import PNotifyAnimate from 'pnotify/dist/es/PNotifyAnimate';
import { deepmerge } from 'utilities/merge'
import './notify.scss';

PNotify.defaults.styling = 'bootstrap4';

export default class NotifyBase {
  notifies: Array<PNotify> = []
  loadHandler: () => void;
  context: HTMLElement;
  scope: string = '';
  stack: any = {};
  defaultStack = {
    dir1: 'up',
    firstpos1: 1,
    dir2: 'left',
    firstpos2: 1,
    context: this.context
  };
  options: any = {};
  defaultOptions = {
    // hide: false,
    delay: 4000,
    modules: {
      Animate: {
        animate: true,
        inClass: 'fadeInUp',
        outClass: 'fadeOutRight'
      }
    },
    width: "100%",
    cornerclass: "no-border-radius",
    addclass: "stack-custom-bottom bg-primary",
  };
  elementId = 'notify-wrap';
  init(){
    PNotifyAnimate;
    this.setEvent();
  }
  setEvent(){
    let w = watch(App.store.getState, this.scope, isEqual);
    this.context = document.getElementById(this.elementId);
    App.store.subscribe(w((newVal, oldVal, objectPath) => {
      this.onEvent(newVal, oldVal, objectPath);
    }), true);
  }
  onEvent(newVal, oldVal, projectPath){
    let notify = this.createNotify(newVal.options);
    return notify;
  }
  public createNotify(options){
    let defaultOptions = deepmerge(this.defaultOptions, this.options);
    options = deepmerge(defaultOptions, options)
    options['stack'] = deepmerge(this.defaultStack, this.stack);
    return PNotify.alert(options);
  }
}
